import { TextField, TextFieldProps } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import React from "react";
import { useFieldValueAndValidation } from "ui/componentes/Form/functions";

interface InputFieldFormikProps {
    validate?: (value) => string | undefined;
}

const InputFieldFormik: React.FC<TextFieldProps & InputFieldFormikProps> = (
    props
) => {
    const { handleChange, handleBlur } = useFormikContext<any>();

    const { value, error, hasTouched } = useFieldValueAndValidation(props.name);
    const showError = !!error && hasTouched;

    return (
        <Field
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            component={TextField}
            {...props}
            error={showError}
            helperText={showError ? error : props.helperText}
        />
    );
};

export { InputFieldFormik };
